module.exports = __webpack_public_path__ + "static/img/组 11@2x.324e74c1.png";